import { ReactNode, useMemo, useState } from 'react';
import { NavItem } from '@components/layout/layout.type';

import { EventNavigationContext } from './event-navigation-context';

export const EventNavigationProvider = ({ children }: { children: ReactNode }) => {
  const [eventNavigationItems, setEventNavigationItems] = useState<NavItem[]>([]);

  const contextValue = useMemo(
    () => ({
      eventNavigationItems,
      setEventNavigation: setEventNavigationItems,
    }),
    [eventNavigationItems]
  );

  return <EventNavigationContext.Provider value={contextValue}>{children}</EventNavigationContext.Provider>;
};
